import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { AdvantagesAgent } from '../../components/AdvantagesAgent';
import { AgentContentWrapper } from '../../components/AgentContentWrapper';
import { FAQAgent } from '../../components/FAQAgent';
import { HowItWork } from '../../components/HowItWork';
import { agentContent } from '../../components/HowItWork/constants';
import { Layout } from '../../components/Layout';
import { PromoBannerAgent } from '../../components/PromoBannerAgent';
import { VIEWED_TIMEOUT } from '../../constants/timeouts';
import { useTeaserTracking } from '../../hooks/useTeaserTracking';
import { StickyFooterContainer } from '../StickyFooterContainer';

interface IAgentPageProps {
  mainButtonsRef?: React.Ref<HTMLDivElement>;
}

export const AgentPage: React.FC<IAgentPageProps> = ({ mainButtonsRef }) => {
  const { trackShowAdvantages, trackShowSteps } = useTeaserTracking();

  return (
    <div style={{ background: 'black' }}>
      <PromoBannerAgent mainButtonsRef={mainButtonsRef} />
      <AgentContentWrapper>
        <Layout>
          <ActionAfterViewObserver callback={trackShowAdvantages} callbackDelay={VIEWED_TIMEOUT}>
            <AdvantagesAgent />
          </ActionAfterViewObserver>

          <FAQAgent />

          <ActionAfterViewObserver callback={trackShowSteps} callbackDelay={VIEWED_TIMEOUT}>
            <HowItWork uiTheme="var(--theme-black)" content={agentContent} howItWorkRef={undefined} />
          </ActionAfterViewObserver>
        </Layout>
      </AgentContentWrapper>
      <StickyFooterContainer theme="dark" />
    </div>
  );
};

AgentPage.displayName = 'AgentPage';
